export default __webpack_public_path__ + "static/media/1956.fcfb4235.png";